import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { API, useAuth } from "../App";

// Titre d'onglet par page (jimmy-wvw) : « <projet> · <section> », sans le nom de l'appli — le sélecteur d'applis du
// hub (switcher.js) le préfixe de « Studio - ». Sans page reconnue, le titre statique d'index.html reste.
const SECTIONS = [   // [motif de route, clé de libellé]
  [/^\/projects\/new$/, "docTitle.newProject"],
  [/^\/projects\/[^/]+\/scenario-v2/, "docTitle.scenario"],
  [/^\/projects\/[^/]+\/analysis/, "docTitle.analysis"],
  [/^\/projects\/[^/]+\/vision/, "docTitle.vision"],
  [/^\/projects\/[^/]+\/(breakdown|shots)/, "docTitle.breakdown"],
  [/^\/projects\/[^/]+\/production/, "docTitle.production"],
  [/^\/projects\/[^/]+\/plateau/, "docTitle.plateau"],
  [/^\/projects\/[^/]+\/timeline/, "docTitle.timeline"],
  [/^\/projects\/[^/]+\/toolbox/, "docTitle.toolbox"],
  [/^\/projects\/[^/]+\/report/, "docTitle.report"],
  [/^\/projects\/[^/]+\/series/, "docTitle.series"],
  [/^\/projects\/[^/]+\/prompts/, "docTitle.prompts"],
  [/^\/projects\/[^/]+\/?$/, null],             // fiche projet : son nom seul
  [/^\/$/, "docTitle.dashboard"],
  [/^\/toolbox/, "docTitle.toolbox"],
  [/^\/library/, "docTitle.library"],
  [/^\/settings/, "docTitle.settings"],
  [/^\/comments/, "docTitle.comments"],
  [/^\/admin\/prompts/, "docTitle.prompts"],
  [/^\/admin/, "docTitle.admin"],
  [/^\/rnd/, "docTitle.rnd"],
  [/^\/login/, "docTitle.login"],
];

let names = {};   // id de projet -> nom (une requête par projet et par session ; vidé à la déconnexion)

export function resetDocumentTitleCache() {
  names = {};
}

export default function DocumentTitle() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { user } = useAuth();
  const userId = user?.id;
  const projectId = (pathname.match(/^\/projects\/([^/]+)/) || [])[1];
  const realProject = projectId && projectId !== "new" ? projectId : null;
  const [fetched, setFetched] = useState({});   // id -> nom, pour re-rendre quand la réponse arrive

  useEffect(() => {
    if (!userId) { names = {}; setFetched({}); return undefined; }   // pas de session : aucune requête, rien gardé
    if (!realProject || realProject in names) return undefined;
    let alive = true;
    const cache = names;   // une réponse arrivée après la déconnexion n'entre pas dans le cache de la session suivante
    axios.get(`${API}/projects/${realProject}`)
      .then((res) => {
        cache[realProject] = res.data?.name || "";
        if (alive) setFetched((f) => ({ ...f, [realProject]: cache[realProject] }));
      })
      .catch(() => {});   // sans accès ou hors ligne : la section seule (réessayé à la prochaine visite)
    return () => { alive = false; };
  }, [realProject, userId]);

  // nom calculé au rendu : jamais celui du projet précédent pendant un changement de projet
  const name = realProject ? (names[realProject] ?? fetched[realProject] ?? "") : "";
  const match = SECTIONS.find(([rx]) => rx.test(pathname));
  useEffect(() => {
    if (!match) return;
    const section = match[1] ? t(match[1]) : "";
    const title = [name, section].filter(Boolean).join(" · ");
    if (title && document.title !== title) document.title = title;
  }, [match, name, t]);

  return null;
}
